export default {
	"total": [{
		"value": "15887",
		"name": "北京"
	}, {
		"value": "264534",
		"name": "天津"
	}, {
		"value": "3101656",
		"name": "河北"
	}, {
		"value": "1352715",
		"name": "山西"
	}, {
		"value": "1562332",
		"name": "河南"
	}, {
		"value": "2587179",
		"name": "山东"
	}, {
		"value": "25005",
		"name": "上海"
	}, {
		"value": "1008645",
		"name": "江苏"
	}, {
		"value": "287697",
		"name": "浙江"
	}, {
		"value": "692140",
		"name": "福建"
	}, {
		"value": "471337",
		"name": "安徽"
	}, {
		"value": "236698",
		"name": "江西"
	}, {
		"value": "455689",
		"name": "湖北"
	}, {
		"value": "340934",
		"name": "湖南"
	}, {
		"value": "1247077",
		"name": "广东"
	}, {
		"value": "165156",
		"name": "广西"
	}, {
		"value": "146293",
		"name": "贵州"
	}, {
		"value": "194409",
		"name": "云南"
	}, {
		"value": "19129",
		"name": "海南"
	}, {
		"value": "170476",
		"name": "黑龙江"
	}, {
		"value": "643341",
		"name": "吉林"
	}, {
		"value": "607883",
		"name": "辽宁"
	}, {
		"value": "2381202",
		"name": "陕西"
	}, {
		"value": "522649",
		"name": "新疆"
	}, {
		"value": "1207331",
		"name": "内蒙古"
	}, {
		"value": "156149",
		"name": "青海"
	}, {
		"value": "420473",
		"name": "宁夏"
	}, {
		"value": "210874",
		"name": "甘肃"
	}, {
		"value": "92140",
		"name": "西藏"
	}, {
		"value": "341062",
		"name": "四川"
	}, {
		"value": "52567",
		"name": "重庆"
	}],
	"list": [{
        "item": [
            {
			"value": "-1",
			"name": "北京"
		}, {
			"value": "18649",
			"name": "天津"
		}, {
			"value": "177814",
			"name": "河北"
		}, {
			"value": "5965",
			"name": "山西"
		}, {
			"value": "6129",
			"name": "河南"
		}, {
			"value": "13942",
			"name": "山东"
		}, {
			"value": "210",
			"name": "上海"
		}, {
			"value": "2674",
			"name": "江苏"
		}, {
			"value": "663",
			"name": "浙江"
		}, {
			"value": "2248",
			"name": "福建"
		}, {
			"value": "509",
			"name": "安徽"
		}, {
			"value": "706",
			"name": "江西"
		}, {
			"value": "828",
			"name": "湖北"
		}, {
			"value": "560",
			"name": "湖南"
		}, {
			"value": "2599",
			"name": "广东"
		}, {
			"value": "144",
			"name": "广西"
		}, {
			"value": "118",
			"name": "贵州"
		}, {
			"value": "137",
			"name": "云南"
		}, {
			"value": "57",
			"name": "海南"
		}, {
			"value": "784",
			"name": "黑龙江"
		}, {
			"value": "2430",
			"name": "吉林"
		}, {
			"value": "5987",
			"name": "辽宁"
		}, {
			"value": "4805",
			"name": "陕西"
		}, {
			"value": "662",
			"name": "新疆"
		}, {
			"value": "10438",
			"name": "内蒙古"
		}, {
			"value": "183",
			"name": "青海"
		}, {
			"value": "430",
			"name": "宁夏"
		}, {
			"value": "90",
			"name": "甘肃"
		}, {
			"value": "82",
			"name": "西藏"
		}, {
			"value": "997",
			"name": "四川"
		}, {
			"value": "137",
			"name": "重庆"
		}],
		"nameName": "北京",
		"toatl": "260977"
	}, {
            "item": [
                {
			"value": "2566",
			"name": "北京"
		}, {
			"value": "-1",
			"name": "天津"
		}, {
			"value": "228129",
			"name": "河北"
		}, {
			"value": "11067",
			"name": "山西"
		}, {
			"value": "7562",
			"name": "河南"
		}, {
			"value": "20018",
			"name": "山东"
		}, {
			"value": "136",
			"name": "上海"
		}, {
			"value": "5599",
			"name": "江苏"
		}, {
			"value": "480",
			"name": "浙江"
		}, {
			"value": "1071",
			"name": "福建"
		}, {
			"value": "644",
			"name": "安徽"
		}, {
			"value": "341",
			"name": "江西"
		}, {
			"value": "1190",
			"name": "湖北"
		}, {
			"value": "355",
			"name": "湖南"
		}, {
			"value": "1104",
			"name": "广东"
		}, {
			"value": "144",
			"name": "广西"
		}, {
			"value": "36",
			"name": "贵州"
		}, {
			"value": "152",
			"name": "云南"
		}, {
			"value": "4",
			"name": "海南"
		}, {
			"value": "910",
			"name": "黑龙江"
		}, {
			"value": "2870",
			"name": "吉林"
		}, {
			"value": "7982",
			"name": "辽宁"
		}, {
			"value": "6976",
			"name": "陕西"
		}, {
			"value": "5634",
			"name": "新疆"
		}, {
			"value": "34012",
			"name": "内蒙古"
		}, {
			"value": "771",
			"name": "青海"
		}, {
			"value": "3805",
			"name": "宁夏"
		}, {
			"value": "323",
			"name": "甘肃"
		}, {
			"value": "241",
			"name": "西藏"
		}, {
			"value": "1130",
			"name": "四川"
		}, {
			"value": "58",
			"name": "重庆"
		}],
		"nameName": "天津",
		"toatl": "345310"
	}, {
            "item": [
                {
			"value": "8222",
			"name": "北京"
		}, {
			"value": "131586",
			"name": "天津"
		}, {
			"value": "-1",
			"name": "河北"
		}, {
			"value": "646588",
			"name": "山西"
		}, {
			"value": "409380",
			"name": "河南"
		}, {
			"value": "1147022",
			"name": "山东"
		}, {
			"value": "1308",
			"name": "上海"
		}, {
			"value": "114420",
			"name": "江苏"
		}, {
			"value": "6536",
			"name": "浙江"
		}, {
			"value": "20800",
			"name": "福建"
		}, {
			"value": "26890",
			"name": "安徽"
		}, {
			"value": "9081",
			"name": "江西"
		}, {
			"value": "39037",
			"name": "湖北"
		}, {
			"value": "20803",
			"name": "湖南"
		}, {
			"value": "28161",
			"name": "广东"
		}, {
			"value": "8645",
			"name": "广西"
		}, {
			"value": "2876",
			"name": "贵州"
		}, {
			"value": "9203",
			"name": "云南"
		}, {
			"value": "569",
			"name": "海南"
		}, {
			"value": "17258",
			"name": "黑龙江"
		}, {
			"value": "41272",
			"name": "吉林"
		}, {
			"value": "115351",
			"name": "辽宁"
		}, {
			"value": "364062",
			"name": "陕西"
		}, {
			"value": "144517",
			"name": "新疆"
		}, {
			"value": "367447",
			"name": "内蒙古"
		}, {
			"value": "39184",
			"name": "青海"
		}, {
			"value": "69242",
			"name": "宁夏"
		}, {
			"value": "32114",
			"name": "甘肃"
		}, {
			"value": "8242",
			"name": "西藏"
		}, {
			"value": "15321",
			"name": "四川"
		}, {
			"value": "2238",
			"name": "重庆"
		}],
		"nameName": "河北",
		"toatl": "3847375"
	}, {
            "item": [
                {
			"value": "387",
			"name": "北京"
		}, {
			"value": "13493",
			"name": "天津"
		}, {
			"value": "1062758",
			"name": "河北"
		}, {
			"value": "-1",
			"name": "山西"
		}, {
			"value": "264712",
			"name": "河南"
		}, {
			"value": "129482",
			"name": "山东"
		}, {
			"value": "126",
			"name": "上海"
		}, {
			"value": "12791",
			"name": "江苏"
		}, {
			"value": "1156",
			"name": "浙江"
		}, {
			"value": "7476",
			"name": "福建"
		}, {
			"value": "6238",
			"name": "安徽"
		}, {
			"value": "2659",
			"name": "江西"
		}, {
			"value": "27618",
			"name": "湖北"
		}, {
			"value": "14534",
			"name": "湖南"
		}, {
			"value": "15326",
			"name": "广东"
		}, {
			"value": "6187",
			"name": "广西"
		}, {
			"value": "2301",
			"name": "贵州"
		}, {
			"value": "7062",
			"name": "云南"
		}, {
			"value": "273",
			"name": "海南"
		}, {
			"value": "3171",
			"name": "黑龙江"
		}, {
			"value": "4248",
			"name": "吉林"
		}, {
			"value": "9601",
			"name": "辽宁"
		}, {
			"value": "1038420",
			"name": "陕西"
		}, {
			"value": "30776",
			"name": "新疆"
		}, {
			"value": "243010",
			"name": "内蒙古"
		}, {
			"value": "9192",
			"name": "青海"
		}, {
			"value": "57321",
			"name": "宁夏"
		}, {
			"value": "40262",
			"name": "甘肃"
		}, {
			"value": "1948",
			"name": "西藏"
		}, {
			"value": "19298",
			"name": "四川"
		}, {
			"value": "1170",
			"name": "重庆"
		}],
		"nameName": "山西",
		"toatl": "3032996"
	}, {
            "item": [
                {
			"value": "544",
			"name": "北京"
		}, {
			"value": "8184",
			"name": "天津"
		}, {
			"value": "193099",
			"name": "河北"
		}, {
			"value": "331575",
			"name": "山西"
		}, {
            "name": "河南",
            "value": "-1",
		}, {
			"value": "406481",
			"name": "山东"
		}, {
			"value": "2135",
			"name": "上海"
		}, {
			"value": "68518",
			"name": "江苏"
		}, {
			"value": "37144",
			"name": "浙江"
		}, {
			"value": "84891",
			"name": "福建"
		}, {
			"value": "132776",
			"name": "安徽"
		}, {
			"value": "29987",
			"name": "江西"
		}, {
			"value": "181824",
			"name": "湖北"
		}, {
			"value": "57054",
			"name": "湖南"
		}, {
			"value": "130884",
			"name": "广东"
		}, {
			"value": "27362",
			"name": "广西"
		}, {
			"value": "4730",
			"name": "贵州"
		}, {
			"value": "16511",
			"name": "云南"
		}, {
			"value": "2260",
			"name": "海南"
		}, {
			"value": "1614",
			"name": "黑龙江"
		}, {
			"value": "3259",
			"name": "吉林"
		}, {
			"value": "10847",
			"name": "辽宁"
		}, {
			"value": "409516",
			"name": "陕西"
		}, {
			"value": "100230",
			"name": "新疆"
		}, {
			"value": "20960",
			"name": "内蒙古"
		}, {
			"value": "26612",
			"name": "青海"
		}, {
			"value": "86173",
			"name": "宁夏"
		}, {
			"value": "38589",
			"name": "甘肃"
		}, {
			"value": "14172",
			"name": "西藏"
		}, {
			"value": "22655",
			"name": "四川"
		}, {
			"value": "5074",
			"name": "重庆"
		}],
		"nameName": "河南",
		"toatl": "2455660"
	}, {
            "item": [
                {
			"value": "1141",
			"name": "北京"
		}, {
			"value": "18560",
			"name": "天津"
		}, {
			"value": "412739",
			"name": "河北"
		}, {
			"value": "111564",
			"name": "山西"
		}, {
			"value": "242178",
			"name": "河南"
		}, {
			"value": "-1",
			"name": "山东"
		}, {
			"value": "3736",
			"name": "上海"
		}, {
			"value": "258496",
			"name": "江苏"
		}, {
			"value": "17641",
			"name": "浙江"
		}, {
			"value": "46710",
			"name": "福建"
		}, {
			"value": "94592",
			"name": "安徽"
		}, {
			"value": "23387",
			"name": "江西"
		}, {
			"value": "40121",
			"name": "湖北"
		}, {
			"value": "15977",
			"name": "湖南"
		}, {
			"value": "39135",
			"name": "广东"
		}, {
			"value": "17622",
			"name": "广西"
		}, {
			"value": "2458",
			"name": "贵州"
		}, {
			"value": "8549",
			"name": "云南"
		}, {
			"value": "1017",
			"name": "海南"
		}, {
			"value": "7356",
			"name": "黑龙江"
		}, {
			"value": "18053",
			"name": "吉林"
		}, {
			"value": "31956",
			"name": "辽宁"
		}, {
			"value": "165493",
			"name": "陕西"
		}, {
			"value": "81147",
			"name": "新疆"
		}, {
			"value": "39704",
			"name": "内蒙古"
		}, {
			"value": "17649",
			"name": "青海"
		}, {
			"value": "26527",
			"name": "宁夏"
		}, {
			"value": "13483",
			"name": "甘肃"
		}, {
			"value": "4846",
			"name": "西藏"
		}, {
			"value": "14767",
			"name": "四川"
		}, {
			"value": "2398",
			"name": "重庆"
		}],
		"nameName": "山东",
		"toatl": "1779002"
	}, {
            "item": [
                {
			"value": "162",
			"name": "北京"
		}, {
			"value": "7242",
			"name": "天津"
		}, {
			"value": "16618",
			"name": "河北"
		}, {
			"value": "2522",
			"name": "山西"
		}, {
			"value": "14922",
			"name": "河南"
		}, {
			"value": "26032",
			"name": "山东"
		}, {
			"value": "-1",
			"name": "上海"
		}, {
			"value": "232126",
			"name": "江苏"
		}, {
			"value": "42922",
			"name": "浙江"
		}, {
			"value": "23886",
			"name": "福建"
		}, {
			"value": "15824",
			"name": "安徽"
		}, {
			"value": "13162",
			"name": "江西"
		}, {
			"value": "8582",
			"name": "湖北"
		}, {
			"value": "2800",
			"name": "湖南"
		}, {
			"value": "18540",
			"name": "广东"
		}, {
			"value": "1103",
			"name": "广西"
		}, {
			"value": "419",
			"name": "贵州"
		}, {
			"value": "1149",
			"name": "云南"
		}, {
			"value": "117",
			"name": "海南"
		}, {
			"value": "1008",
			"name": "黑龙江"
		}, {
			"value": "3114",
			"name": "吉林"
		}, {
			"value": "6367",
			"name": "辽宁"
		}, {
			"value": "10029",
			"name": "陕西"
		}, {
			"value": "2128",
			"name": "新疆"
		}, {
			"value": "1417",
			"name": "内蒙古"
		}, {
			"value": "242",
			"name": "青海"
		}, {
			"value": "571",
			"name": "宁夏"
		}, {
			"value": "358",
			"name": "甘肃"
		}, {
			"value": "99",
			"name": "西藏"
		}, {
			"value": "4968",
			"name": "四川"
		}, {
			"value": "1315",
			"name": "重庆"
		}],
		"nameName": "上海",
		"toatl": "459744"
	}, {
            "item": [
                {
			"value": "369",
			"name": "北京"
		}, {
			"value": "5535",
			"name": "天津"
		}, {
			"value": "62767",
			"name": "河北"
		}, {
			"value": "11245",
			"name": "山西"
		}, {
			"value": "66749",
			"name": "河南"
		}, {
			"value": "357209",
			"name": "山东"
		}, {
			"value": "9000",
			"name": "上海"
		}, {
			"value": "-1",
			"name": "江苏"
		}, {
			"value": "35951",
			"name": "浙江"
		}, {
			"value": "48024",
			"name": "福建"
		}, {
			"value": "141388",
			"name": "安徽"
		}, {
			"value": "25201",
			"name": "江西"
		}, {
			"value": "21363",
			"name": "湖北"
		}, {
			"value": "9289",
			"name": "湖南"
		}, {
			"value": "24766",
			"name": "广东"
		}, {
			"value": "5876",
			"name": "广西"
		}, {
			"value": "1243",
			"name": "贵州"
		}, {
			"value": "2733",
			"name": "云南"
		}, {
			"value": "445",
			"name": "海南"
		}, {
			"value": "1072",
			"name": "黑龙江"
		}, {
			"value": "2623",
			"name": "吉林"
		}, {
			"value": "4735",
			"name": "辽宁"
		}, {
			"value": "24950",
			"name": "陕西"
		}, {
			"value": "9566",
			"name": "新疆"
		}, {
			"value": "3989",
			"name": "内蒙古"
		}, {
			"value": "2968",
			"name": "青海"
		}, {
			"value": "3957",
			"name": "宁夏"
		}, {
			"value": "1228",
			"name": "甘肃"
		}, {
			"value": "2000",
			"name": "西藏"
		}, {
			"value": "7578",
			"name": "四川"
		}, {
			"value": "2291",
			"name": "重庆"
		}],
		"nameName": "江苏",
		"toatl": "896110"
	}, {
            "item": [
                {
			"value": "66",
			"name": "北京"
		}, {
			"value": "2501",
			"name": "天津"
		}, {
			"value": "8233",
			"name": "河北"
		}, {
			"value": "1329",
			"name": "山西"
		}, {
			"value": "8207",
			"name": "河南"
		}, {
			"value": "13818",
			"name": "山东"
		}, {
			"value": "2242",
			"name": "上海"
		}, {
			"value": "30523",
			"name": "江苏"
		}, {
			"value": "-1",
			"name": "浙江"
		}, {
			"value": "31856",
			"name": "福建"
		}, {
			"value": "10555",
			"name": "安徽"
		}, {
			"value": "15033",
			"name": "江西"
		}, {
			"value": "3879",
			"name": "湖北"
		}, {
			"value": "1608",
			"name": "湖南"
		}, {
			"value": "15735",
			"name": "广东"
		}, {
			"value": "1780",
			"name": "广西"
		}, {
			"value": "491",
			"name": "贵州"
		}, {
			"value": "772",
			"name": "云南"
		}, {
			"value": "80",
			"name": "海南"
		}, {
			"value": "672",
			"name": "黑龙江"
		}, {
			"value": "2534",
			"name": "吉林"
		}, {
			"value": "2598",
			"name": "辽宁"
		}, {
			"value": "4569",
			"name": "陕西"
		}, {
			"value": "1150",
			"name": "新疆"
		}, {
			"value": "342",
			"name": "内蒙古"
		}, {
			"value": "130",
			"name": "青海"
		}, {
			"value": "406",
			"name": "宁夏"
		}, {
			"value": "339",
			"name": "甘肃"
		}, {
			"value": "56",
			"name": "西藏"
		}, {
			"value": "2605",
			"name": "四川"
		}, {
			"value": "581",
			"name": "重庆"
		}],
		"nameName": "浙江",
		"toatl": "164690"
	}, {
            "item": [
                {
			"value": "15",
			"name": "北京"
		}, {
			"value": "157",
			"name": "天津"
		}, {
			"value": "1266",
			"name": "河北"
		}, {
			"value": "652",
			"name": "山西"
		}, {
			"value": "1266",
			"name": "河南"
		}, {
			"value": "2554",
			"name": "山东"
		}, {
			"value": "67",
			"name": "上海"
		}, {
			"value": "812",
			"name": "江苏"
		}, {
			"value": "1353",
			"name": "浙江"
		}, {
			"value": "-1",
			"name": "福建"
		}, {
			"value": "298",
			"name": "安徽"
		}, {
			"value": "3188",
			"name": "江西"
		}, {
			"value": "796",
			"name": "湖北"
		}, {
			"value": "550",
			"name": "湖南"
		}, {
			"value": "36114",
			"name": "广东"
		}, {
			"value": "288",
			"name": "广西"
		}, {
			"value": "122",
			"name": "贵州"
		}, {
			"value": "233",
			"name": "云南"
		}, {
			"value": "28",
			"name": "海南"
		}, {
			"value": "17",
			"name": "黑龙江"
		}, {
			"value": "54",
			"name": "吉林"
		}, {
			"value": "168",
			"name": "辽宁"
		}, {
			"value": "461",
			"name": "陕西"
		}, {
			"value": "427",
			"name": "新疆"
		}, {
			"value": "42",
			"name": "内蒙古"
		}, {
			"value": "19",
			"name": "青海"
		}, {
			"value": "22",
			"name": "宁夏"
		}, {
			"value": "105",
			"name": "甘肃"
		}, {
			"value": "6",
			"name": "西藏"
		}, {
			"value": "209",
			"name": "四川"
		}, {
			"value": "57",
			"name": "重庆"
		}],
		"nameName": "福建",
		"toatl": "51346"
	}, {
		"item": [{
			"value": "201",
			"name": "北京"
		}, {
			"value": "3104",
			"name": "天津"
		}, {
			"value": "26797",
			"name": "河北"
		}, {
			"value": "10127",
			"name": "山西"
		}, {
			"value": "278100",
			"name": "河南"
		}, {
			"value": "133765",
			"name": "山东"
		}, {
			"value": "3853",
			"name": "上海"
		}, {
			"value": "195263",
			"name": "江苏"
		}, {
			"value": "105441",
			"name": "浙江"
		}, {
			"value": "107746",
			"name": "福建"
		}, {
			"value": "-1",
			"name": "安徽"
		}, {
			"value": "66621",
			"name": "江西"
		}, {
			"value": "37078",
			"name": "湖北"
		}, {
			"value": "13355",
			"name": "湖南"
		}, {
			"value": "108731",
			"name": "广东"
		}, {
			"value": "9766",
			"name": "广西"
		}, {
			"value": "1671",
			"name": "贵州"
		}, {
			"value": "7268",
			"name": "云南"
		}, {
			"value": "1104",
			"name": "海南"
		}, {
			"value": "942",
			"name": "黑龙江"
		}, {
			"value": "1812",
			"name": "吉林"
		}, {
			"value": "3188",
			"name": "辽宁"
		}, {
			"value": "37751",
			"name": "陕西"
		}, {
			"value": "14445",
			"name": "新疆"
		}, {
			"value": "2099",
			"name": "内蒙古"
		}, {
			"value": "3940",
			"name": "青海"
		}, {
			"value": "3586",
			"name": "宁夏"
		}, {
			"value": "1899",
			"name": "甘肃"
		}, {
			"value": "1866",
			"name": "西藏"
		}, {
			"value": "6094",
			"name": "四川"
		}, {
			"value": "3168",
			"name": "重庆"
		}],
		"nameName": "安徽",
		"toatl": "1190781"
	}, {
		"item": [{
			"value": "73",
			"name": "北京"
		}, {
			"value": "1039",
			"name": "天津"
		}, {
			"value": "8670",
			"name": "河北"
		}, {
			"value": "1601",
			"name": "山西"
		}, {
			"value": "16951",
			"name": "河南"
		}, {
			"value": "9512",
			"name": "山东"
		}, {
			"value": "471",
			"name": "上海"
		}, {
			"value": "13854",
			"name": "江苏"
		}, {
			"value": "21655",
			"name": "浙江"
		}, {
			"value": "172295",
			"name": "福建"
		}, {
			"value": "18292",
			"name": "安徽"
		}, {
			"value": "-1",
			"name": "江西"
		}, {
			"value": "30504",
			"name": "湖北"
		}, {
			"value": "87452",
			"name": "湖南"
		}, {
			"value": "336937",
			"name": "广东"
		}, {
			"value": "25710",
			"name": "广西"
		}, {
			"value": "10628",
			"name": "贵州"
		}, {
			"value": "13343",
			"name": "云南"
		}, {
			"value": "7000",
			"name": "海南"
		}, {
			"value": "1184",
			"name": "黑龙江"
		}, {
			"value": "2053",
			"name": "吉林"
		}, {
			"value": "1735",
			"name": "辽宁"
		}, {
			"value": "11797",
			"name": "陕西"
		}, {
			"value": "4003",
			"name": "新疆"
		}, {
			"value": "2618",
			"name": "内蒙古"
		}, {
			"value": "4759",
			"name": "青海"
		}, {
			"value": "2919",
			"name": "宁夏"
		}, {
			"value": "2066",
			"name": "甘肃"
		}, {
			"value": "3647",
			"name": "西藏"
		}, {
			"value": "8462",
			"name": "四川"
		}, {
			"value": "1695",
			"name": "重庆"
		}],
		"nameName": "江西",
		"toatl": "822925"
	}, {
		"item": [{
			"value": "56",
			"name": "北京"
		}, {
			"value": "609",
			"name": "天津"
		}, {
			"value": "4655",
			"name": "河北"
		}, {
			"value": "3126",
			"name": "山西"
		}, {
			"value": "60620",
			"name": "河南"
		}, {
			"value": "5862",
			"name": "山东"
		}, {
			"value": "194",
			"name": "上海"
		}, {
			"value": "4225",
			"name": "江苏"
		}, {
			"value": "4006",
			"name": "浙江"
		}, {
			"value": "43041",
			"name": "福建"
		}, {
			"value": "7178",
			"name": "安徽"
		}, {
			"value": "9438",
			"name": "江西"
		}, {
			"value": "-1",
			"name": "湖北"
		}, {
			"value": "46057",
			"name": "湖南"
		}, {
			"value": "80758",
			"name": "广东"
		}, {
			"value": "11589",
			"name": "广西"
		}, {
			"value": "4358",
			"name": "贵州"
		}, {
			"value": "4136",
			"name": "云南"
		}, {
			"value": "922",
			"name": "海南"
		}, {
			"value": "102",
			"name": "黑龙江"
		}, {
			"value": "545",
			"name": "吉林"
		}, {
			"value": "777",
			"name": "辽宁"
		}, {
			"value": "33640",
			"name": "陕西"
		}, {
			"value": "4724",
			"name": "新疆"
		}, {
			"value": "1085",
			"name": "内蒙古"
		}, {
			"value": "1883",
			"name": "青海"
		}, {
			"value": "5252",
			"name": "宁夏"
		}, {
			"value": "1021",
			"name": "甘肃"
		}, {
			"value": "1452",
			"name": "西藏"
		}, {
			"value": "5009",
			"name": "四川"
		}, {
			"value": "7774",
			"name": "重庆"
		}],
		"nameName": "湖北",
		"toatl": "354094"
	}, {
		"item": [{
			"value": "12",
			"name": "北京"
		}, {
			"value": "177",
			"name": "天津"
		}, {
			"value": "1530",
			"name": "河北"
		}, {
			"value": "184",
			"name": "山西"
		}, {
			"value": "1384",
			"name": "河南"
		}, {
			"value": "1023",
			"name": "山东"
		}, {
			"value": "39",
			"name": "上海"
		}, {
			"value": "1214",
			"name": "江苏"
		}, {
			"value": "675",
			"name": "浙江"
		}, {
			"value": "4435",
			"name": "福建"
		}, {
			"value": "474",
			"name": "安徽"
		}, {
			"value": "12968",
			"name": "江西"
		}, {
			"value": "8707",
			"name": "湖北"
		}, {
			"value": "-1",
			"name": "湖南"
		}, {
			"value": "90065",
			"name": "广东"
		}, {
			"value": "10937",
			"name": "广西"
		}, {
			"value": "8896",
			"name": "贵州"
		}, {
			"value": "2544",
			"name": "云南"
		}, {
			"value": "351",
			"name": "海南"
		}, {
			"value": "160",
			"name": "黑龙江"
		}, {
			"value": "358",
			"name": "吉林"
		}, {
			"value": "302",
			"name": "辽宁"
		}, {
			"value": "1548",
			"name": "陕西"
		}, {
			"value": "281",
			"name": "新疆"
		}, {
			"value": "52",
			"name": "内蒙古"
		}, {
			"value": "54",
			"name": "青海"
		}, {
			"value": "80",
			"name": "宁夏"
		}, {
			"value": "102",
			"name": "甘肃"
		}, {
			"value": "98",
			"name": "西藏"
		}, {
			"value": "942",
			"name": "四川"
		}, {
			"value": "819",
			"name": "重庆"
		}],
		"nameName": "湖南",
		"toatl": "150411"
	}, {
		"item": [{
			"value": "95",
			"name": "北京"
		}, {
			"value": "1273",
			"name": "天津"
		}, {
			"value": "3003",
			"name": "河北"
		}, {
			"value": "505",
			"name": "山西"
		}, {
			"value": "3877",
			"name": "河南"
		}, {
			"value": "4175",
			"name": "山东"
		}, {
			"value": "179",
			"name": "上海"
		}, {
			"value": "3441",
			"name": "江苏"
		}, {
			"value": "3907",
			"name": "浙江"
		}, {
			"value": "42090",
			"name": "福建"
		}, {
			"value": "842",
			"name": "安徽"
		}, {
			"value": "9111",
			"name": "江西"
		}, {
			"value": "3130",
			"name": "湖北"
		}, {
			"value": "11782",
			"name": "湖南"
		}, {
			"value": "-1",
			"name": "广东"
		}, {
			"value": "13770",
			"name": "广西"
		}, {
			"value": "809",
			"name": "贵州"
		}, {
			"value": "1570",
			"name": "云南"
		}, {
			"value": "1352",
			"name": "海南"
		}, {
			"value": "109",
			"name": "黑龙江"
		}, {
			"value": "250",
			"name": "吉林"
		}, {
			"value": "1139",
			"name": "辽宁"
		}, {
			"value": "3632",
			"name": "陕西"
		}, {
			"value": "1102",
			"name": "新疆"
		}, {
			"value": "158",
			"name": "内蒙古"
		}, {
			"value": "76",
			"name": "青海"
		}, {
			"value": "552",
			"name": "宁夏"
		}, {
			"value": "328",
			"name": "甘肃"
		}, {
			"value": "79",
			"name": "西藏"
		}, {
			"value": "2784",
			"name": "四川"
		}, {
			"value": "1120",
			"name": "重庆"
		}],
		"nameName": "广东",
		"toatl": "116240"
	}, {
		"item": [{
			"value": "18",
			"name": "北京"
		}, {
			"value": "59",
			"name": "天津"
		}, {
			"value": "742",
			"name": "河北"
		}, {
			"value": "100",
			"name": "山西"
		}, {
			"value": "1000",
			"name": "河南"
		}, {
			"value": "1001",
			"name": "山东"
		}, {
			"value": "16",
			"name": "上海"
		}, {
			"value": "223",
			"name": "江苏"
		}, {
			"value": "137",
			"name": "浙江"
		}, {
			"value": "6413",
			"name": "福建"
		}, {
			"value": "154",
			"name": "安徽"
		}, {
			"value": "1559",
			"name": "江西"
		}, {
			"value": "719",
			"name": "湖北"
		}, {
			"value": "8044",
			"name": "湖南"
		}, {
			"value": "230422",
			"name": "广东"
		}, {
			"value": "-1",
			"name": "广西"
		}, {
			"value": "4681",
			"name": "贵州"
		}, {
			"value": "21315",
			"name": "云南"
		}, {
			"value": "1810",
			"name": "海南"
		}, {
			"value": "18",
			"name": "黑龙江"
		}, {
			"value": "66",
			"name": "吉林"
		}, {
			"value": "61",
			"name": "辽宁"
		}, {
			"value": "1889",
			"name": "陕西"
		}, {
			"value": "232",
			"name": "新疆"
		}, {
			"value": "14",
			"name": "内蒙古"
		}, {
			"value": "92",
			"name": "青海"
		}, {
			"value": "24",
			"name": "宁夏"
		}, {
			"value": "20",
			"name": "甘肃"
		}, {
			"value": "117",
			"name": "西藏"
		}, {
			"value": "1031",
			"name": "四川"
		}, {
			"value": "374",
			"name": "重庆"
		}],
		"nameName": "广西",
		"toatl": "282351"
	}, {
		"item": [{
			"value": "3",
			"name": "北京"
		}, {
			"value": "8",
			"name": "天津"
		}, {
			"value": "73",
			"name": "河北"
		}, {
			"value": "22",
			"name": "山西"
		}, {
			"value": "317",
			"name": "河南"
		}, {
			"value": "143",
			"name": "山东"
		}, {
			"value": "4",
			"name": "上海"
		}, {
			"value": "27",
			"name": "江苏"
		}, {
			"value": "35",
			"name": "浙江"
		}, {
			"value": "375",
			"name": "福建"
		}, {
			"value": "8",
			"name": "安徽"
		}, {
			"value": "423",
			"name": "江西"
		}, {
			"value": "212",
			"name": "湖北"
		}, {
			"value": "853",
			"name": "湖南"
		}, {
			"value": "2245",
			"name": "广东"
		}, {
			"value": "1684",
			"name": "广西"
		}, {
			"value": "-1",
			"name": "贵州"
		}, {
			"value": "5758",
			"name": "云南"
		}, {
			"value": "1",
			"name": "海南"
		}, {
			"value": "6",
			"name": "黑龙江"
		}, {
			"value": "13",
			"name": "吉林"
		}, {
			"value": "26",
			"name": "辽宁"
		}, {
			"value": "197",
			"name": "陕西"
		}, {
			"value": "68",
			"name": "新疆"
		}, {
			"value": "13",
			"name": "内蒙古"
		}, {
			"value": "35",
			"name": "青海"
		}, {
			"value": "4",
			"name": "宁夏"
		}, {
			"value": "9",
			"name": "甘肃"
		}, {
			"value": "57",
			"name": "西藏"
		}, {
			"value": "1620",
			"name": "四川"
		}, {
			"value": "1415",
			"name": "重庆"
		}],
		"nameName": "贵州",
		"toatl": "15654"
	}, {
		"item": [{
			"value": "23",
			"name": "北京"
		}, {
			"value": "53",
			"name": "天津"
		}, {
			"value": "345",
			"name": "河北"
		}, {
			"value": "69",
			"name": "山西"
		}, {
			"value": "239",
			"name": "河南"
		}, {
			"value": "129",
			"name": "山东"
		}, {
			"value": "3",
			"name": "上海"
		}, {
			"value": "49",
			"name": "江苏"
		}, {
			"value": "25",
			"name": "浙江"
		}, {
			"value": "219",
			"name": "福建"
		}, {
			"value": "34",
			"name": "安徽"
		}, {
			"value": "62",
			"name": "江西"
		}, {
			"value": "31",
			"name": "湖北"
		}, {
			"value": "129",
			"name": "湖南"
		}, {
			"value": "2352",
			"name": "广东"
		}, {
			"value": "3109",
			"name": "广西"
		}, {
			"value": "5199",
			"name": "贵州"
		}, {
			"value": "-1",
			"name": "云南"
		}, {
			"value": "20",
			"name": "海南"
		}, {
			"value": "82",
			"name": "黑龙江"
		}, {
			"value": "129",
			"name": "吉林"
		}, {
			"value": "130",
			"name": "辽宁"
		}, {
			"value": "794",
			"name": "陕西"
		}, {
			"value": "97",
			"name": "新疆"
		}, {
			"value": "198",
			"name": "内蒙古"
		}, {
			"value": "85",
			"name": "青海"
		}, {
			"value": "47",
			"name": "宁夏"
		}, {
			"value": "45",
			"name": "甘肃"
		}, {
			"value": "1059",
			"name": "西藏"
		}, {
			"value": "3821",
			"name": "四川"
		}, {
			"value": "55",
			"name": "重庆"
		}],
		"nameName": "云南",
		"toatl": "18632"
	}, {
		"item": [{
			"value": "0",
			"name": "北京"
		}, {
			"value": "1",
			"name": "天津"
		}, {
			"value": "9",
			"name": "河北"
		}, {
			"value": "1",
			"name": "山西"
		}, {
			"value": "12",
			"name": "河南"
		}, {
			"value": "59",
			"name": "山东"
		}, {
			"value": "0",
			"name": "上海"
		}, {
			"value": "7",
			"name": "江苏"
		}, {
			"value": "6",
			"name": "浙江"
		}, {
			"value": "192",
			"name": "福建"
		}, {
			"value": "60",
			"name": "安徽"
		}, {
			"value": "42",
			"name": "江西"
		}, {
			"value": "18",
			"name": "湖北"
		}, {
			"value": "30",
			"name": "湖南"
		}, {
			"value": "4883",
			"name": "广东"
		}, {
			"value": "75",
			"name": "广西"
		}, {
			"value": "4",
			"name": "贵州"
		}, {
			"value": "0",
			"name": "云南"
		}, {
			"value": "-1",
			"name": "海南"
		}, {
			"value": "1",
			"name": "黑龙江"
		}, {
			"value": "0",
			"name": "吉林"
		}, {
			"value": "1",
			"name": "辽宁"
		}, {
			"value": "103",
			"name": "陕西"
		}, {
			"value": "7",
			"name": "新疆"
		}, {
			"value": "8",
			"name": "内蒙古"
		}, {
			"value": "0",
			"name": "青海"
		}, {
			"value": "1",
			"name": "宁夏"
		}, {
			"name": "甘肃"
		}, {
			"value": "13",
			"name": "西藏"
		}, {
			"value": "29",
			"name": "四川"
		}, {
			"value": "3",
			"name": "重庆"
		}],
		"nameName": "海南",
		"toatl": "5565"
	}, {
		"item": [{
			"value": "214",
			"name": "北京"
		}, {
			"value": "13149",
			"name": "天津"
		}, {
			"value": "124658",
			"name": "河北"
		}, {
			"value": "12258",
			"name": "山西"
		}, {
			"value": "27158",
			"name": "河南"
		}, {
			"value": "101927",
			"name": "山东"
		}, {
			"value": "293",
			"name": "上海"
		}, {
			"value": "9269",
			"name": "江苏"
		}, {
			"value": "699",
			"name": "浙江"
		}, {
			"value": "2247",
			"name": "福建"
		}, {
			"value": "2829",
			"name": "安徽"
		}, {
			"value": "1269",
			"name": "江西"
		}, {
			"value": "3540",
			"name": "湖北"
		}, {
			"value": "2440",
			"name": "湖南"
		}, {
			"value": "4786",
			"name": "广东"
		}, {
			"value": "902",
			"name": "广西"
		}, {
			"value": "218",
			"name": "贵州"
		}, {
			"value": "1295",
			"name": "云南"
		}, {
			"value": "187",
			"name": "海南"
		}, {
			"value": "-1",
			"name": "黑龙江"
		}, {
			"value": "268698",
			"name": "吉林"
		}, {
			"value": "219772",
			"name": "辽宁"
		}, {
			"value": "13762",
			"name": "陕西"
		}, {
			"value": "8506",
			"name": "新疆"
		}, {
			"value": "105243",
			"name": "内蒙古"
		}, {
			"value": "3454",
			"name": "青海"
		}, {
			"value": "2753",
			"name": "宁夏"
		}, {
			"value": "660",
			"name": "甘肃"
		}, {
			"value": "1290",
			"name": "西藏"
		}, {
			"value": "1115",
			"name": "四川"
		}, {
			"value": "159",
			"name": "重庆"
		}],
		"nameName": "黑龙江",
		"toatl": "934750"
	}, {
		"item": [{
			"value": "317",
			"name": "北京"
		}, {
			"value": "8515",
			"name": "天津"
		}, {
			"value": "95885",
			"name": "河北"
		}, {
			"value": "7595",
			"name": "山西"
		}, {
			"value": "19643",
			"name": "河南"
		}, {
			"value": "51545",
			"name": "山东"
		}, {
			"value": "200",
			"name": "上海"
		}, {
			"value": "8409",
			"name": "江苏"
		}, {
			"value": "978",
			"name": "浙江"
		}, {
			"value": "3310",
			"name": "福建"
		}, {
			"value": "1507",
			"name": "安徽"
		}, {
			"value": "1499",
			"name": "江西"
		}, {
			"value": "2322",
			"name": "湖北"
		}, {
			"value": "2153",
			"name": "湖南"
		}, {
			"value": "7878",
			"name": "广东"
		}, {
			"value": "619",
			"name": "广西"
		}, {
			"value": "258",
			"name": "贵州"
		}, {
			"value": "753",
			"name": "云南"
		}, {
			"value": "89",
			"name": "海南"
		}, {
			"value": "35457",
			"name": "黑龙江"
		}, {
			"value": "-1",
			"name": "吉林"
		}, {
			"value": "151695",
			"name": "辽宁"
		}, {
			"value": "25494",
			"name": "陕西"
		}, {
			"value": "7589",
			"name": "新疆"
		}, {
			"value": "52937",
			"name": "内蒙古"
		}, {
			"value": "1936",
			"name": "青海"
		}, {
			"value": "3274",
			"name": "宁夏"
		}, {
			"value": "783",
			"name": "甘肃"
		}, {
			"value": "782",
			"name": "西藏"
		}, {
			"value": "4080",
			"name": "四川"
		}, {
			"value": "294",
			"name": "重庆"
		}],
		"nameName": "吉林",
		"toatl": "497796"
	}, {
		"item": [{
			"value": "908",
			"name": "北京"
		}, {
			"value": "21017",
			"name": "天津"
		}, {
			"value": "512186",
			"name": "河北"
		}, {
			"value": "40945",
			"name": "山西"
		}, {
			"value": "53625",
			"name": "河南"
		}, {
			"value": "137600",
			"name": "山东"
		}, {
			"value": "437",
			"name": "上海"
		}, {
			"value": "39913",
			"name": "江苏"
		}, {
			"value": "2558",
			"name": "浙江"
		}, {
			"value": "9953",
			"name": "福建"
		}, {
			"value": "6767",
			"name": "安徽"
		}, {
			"value": "3942",
			"name": "江西"
		}, {
			"value": "8791",
			"name": "湖北"
		}, {
			"value": "5022",
			"name": "湖南"
		}, {
			"value": "11545",
			"name": "广东"
		}, {
			"value": "2351",
			"name": "广西"
		}, {
			"value": "791",
			"name": "贵州"
		}, {
			"value": "3240",
			"name": "云南"
		}, {
			"value": "342",
			"name": "海南"
		}, {
			"value": "91877",
			"name": "黑龙江"
		}, {
			"value": "272051",
			"name": "吉林"
		}, {
			"value": "-1",
			"name": "辽宁"
		}, {
			"value": "43428",
			"name": "陕西"
		}, {
			"value": "18666",
			"name": "新疆"
		}, {
			"value": "182353",
			"name": "内蒙古"
		}, {
			"value": "4684",
			"name": "青海"
		}, {
			"value": "11016",
			"name": "宁夏"
		}, {
			"value": "5113",
			"name": "甘肃"
		}, {
			"value": "1441",
			"name": "西藏"
		}, {
			"value": "4702",
			"name": "四川"
		}, {
			"value": "675",
			"name": "重庆"
		}],
		"nameName": "辽宁",
		"toatl": "1497939"
	}, {
		"item": [{
			"value": "21",
			"name": "北京"
		}, {
			"value": "538",
			"name": "天津"
		}, {
			"value": "6509",
			"name": "河北"
		}, {
			"value": "120020",
			"name": "山西"
		}, {
			"value": "55256",
			"name": "河南"
		}, {
			"value": "4166",
			"name": "山东"
		}, {
			"value": "42",
			"name": "上海"
		}, {
			"value": "769",
			"name": "江苏"
		}, {
			"value": "304",
			"name": "浙江"
		}, {
			"value": "1975",
			"name": "福建"
		}, {
			"value": "530",
			"name": "安徽"
		}, {
			"value": "1564",
			"name": "江西"
		}, {
			"value": "14580",
			"name": "湖北"
		}, {
			"value": "4151",
			"name": "湖南"
		}, {
			"value": "7664",
			"name": "广东"
		}, {
			"value": "1704",
			"name": "广西"
		}, {
			"value": "1195",
			"name": "贵州"
		}, {
			"value": "5301",
			"name": "云南"
		}, {
			"value": "79",
			"name": "海南"
		}, {
			"value": "171",
			"name": "黑龙江"
		}, {
			"value": "209",
			"name": "吉林"
		}, {
			"value": "606",
			"name": "辽宁"
		}, {
			"value": "-1",
			"name": "陕西"
		}, {
			"value": "19889",
			"name": "新疆"
		}, {
			"value": "82187",
			"name": "内蒙古"
		}, {
			"value": "8794",
			"name": "青海"
		}, {
			"value": "71289",
			"name": "宁夏"
		}, {
			"value": "21808",
			"name": "甘肃"
		}, {
			"value": "3101",
			"name": "西藏"
		}, {
			"value": "42000",
			"name": "四川"
		}, {
			"value": "1782",
			"name": "重庆"
		}],
		"nameName": "陕西",
		"toatl": "478204"
	}, {
		"item": [{
			"value": "10",
			"name": "北京"
		}, {
			"value": "16",
			"name": "天津"
		}, {
			"value": "520",
			"name": "河北"
		}, {
			"value": "175",
			"name": "山西"
		}, {
			"value": "563",
			"name": "河南"
		}, {
			"value": "333",
			"name": "山东"
		}, {
			"value": "1",
			"name": "上海"
		}, {
			"value": "35",
			"name": "江苏"
		}, {
			"value": "21",
			"name": "浙江"
		}, {
			"value": "32",
			"name": "福建"
		}, {
			"value": "382",
			"name": "安徽"
		}, {
			"value": "35",
			"name": "江西"
		}, {
			"value": "57",
			"name": "湖北"
		}, {
			"value": "45",
			"name": "湖南"
		}, {
			"value": "78",
			"name": "广东"
		}, {
			"value": "9",
			"name": "广西"
		}, {
			"value": "13",
			"name": "贵州"
		}, {
			"value": "6",
			"name": "云南"
		}, {
			"value": "0",
			"name": "海南"
		}, {
			"value": "10",
			"name": "黑龙江"
		}, {
			"value": "9",
			"name": "吉林"
		}, {
			"value": "19",
			"name": "辽宁"
		}, {
			"value": "640",
			"name": "陕西"
		}, {
			"value": "-1",
			"name": "新疆"
		}, {
			"value": "262",
			"name": "内蒙古"
		}, {
			"value": "2005",
			"name": "青海"
		}, {
			"value": "670",
			"name": "宁夏"
		}, {
			"value": "2784",
			"name": "甘肃"
		}, {
			"value": "344",
			"name": "西藏"
		}, {
			"value": "268",
			"name": "四川"
		}, {
			"value": "37",
			"name": "重庆"
		}],
		"nameName": "新疆",
		"toatl": "9379"
	}, {
		"item": [{
			"value": "293",
			"name": "北京"
		}, {
			"value": "3893",
			"name": "天津"
		}, {
			"value": "132487",
			"name": "河北"
		}, {
			"value": "28554",
			"name": "山西"
		}, {
			"value": "4701",
			"name": "河南"
		}, {
			"value": "15024",
			"name": "山东"
		}, {
			"value": "37",
			"name": "上海"
		}, {
			"value": "1870",
			"name": "江苏"
		}, {
			"value": "83",
			"name": "浙江"
		}, {
			"value": "332",
			"name": "福建"
		}, {
			"value": "631",
			"name": "安徽"
		}, {
			"value": "172",
			"name": "江西"
		}, {
			"value": "822",
			"name": "湖北"
		}, {
			"value": "396",
			"name": "湖南"
		}, {
			"value": "546",
			"name": "广东"
		}, {
			"value": "142",
			"name": "广西"
		}, {
			"value": "57",
			"name": "贵州"
		}, {
			"value": "301",
			"name": "云南"
		}, {
			"value": "14",
			"name": "海南"
		}, {
			"value": "6270",
			"name": "黑龙江"
		}, {
			"value": "16042",
			"name": "吉林"
		}, {
			"value": "32125",
			"name": "辽宁"
		}, {
			"value": "33876",
			"name": "陕西"
		}, {
			"value": "13158",
			"name": "新疆"
		}, {
			"value": "-1",
			"name": "内蒙古"
		}, {
			"value": "1898",
			"name": "青海"
		}, {
			"value": "27848",
			"name": "宁夏"
		}, {
			"value": "24744",
			"name": "甘肃"
		}, {
			"value": "762",
			"name": "西藏"
		}, {
			"value": "1524",
			"name": "四川"
		}, {
			"value": "139",
			"name": "重庆"
		}],
		"nameName": "内蒙古",
		"toatl": "348741"
	}, {
		"item": [{
			"value": "0",
			"name": "北京"
		}, {
			"value": "6",
			"name": "天津"
		}, {
			"value": "32",
			"name": "河北"
		}, {
			"value": "178",
			"name": "山西"
		}, {
			"value": "308",
			"name": "河南"
		}, {
			"value": "135",
			"name": "山东"
		}, {
			"value": "0",
			"name": "上海"
		}, {
			"value": "164",
			"name": "江苏"
		}, {
			"value": "0",
			"name": "浙江"
		}, {
			"value": "4",
			"name": "福建"
		}, {
			"value": "14",
			"name": "安徽"
		}, {
			"value": "14",
			"name": "江西"
		}, {
			"value": "19",
			"name": "湖北"
		}, {
			"value": "4",
			"name": "湖南"
		}, {
			"value": "49",
			"name": "广东"
		}, {
			"value": "5",
			"name": "广西"
		}, {
			"value": "10",
			"name": "贵州"
		}, {
			"value": "80",
			"name": "云南"
		}, {
			"value": "0",
			"name": "海南"
		}, {
			"value": "7",
			"name": "黑龙江"
		}, {
			"value": "0",
			"name": "吉林"
		}, {
			"value": "4",
			"name": "辽宁"
		}, {
			"value": "502",
			"name": "陕西"
		}, {
			"value": "1597",
			"name": "新疆"
		}, {
			"value": "156",
			"name": "内蒙古"
		}, {
			"value": "-1",
			"name": "青海"
		}, {
			"value": "263",
			"name": "宁夏"
		}, {
			"value": "1184",
			"name": "甘肃"
		}, {
			"value": "14067",
			"name": "西藏"
		}, {
			"value": "1092",
			"name": "四川"
		}, {
			"value": "249",
			"name": "重庆"
		}],
		"nameName": "青海",
		"toatl": "20143"
	}, {
		"item": [{
			"value": "90",
			"name": "北京"
		}, {
			"value": "1885",
			"name": "天津"
		}, {
			"value": "15366",
			"name": "河北"
		}, {
			"value": "3043",
			"name": "山西"
		}, {
			"value": "8639",
			"name": "河南"
		}, {
			"value": "671",
			"name": "山东"
		}, {
			"value": "20",
			"name": "上海"
		}, {
			"value": "883",
			"name": "江苏"
		}, {
			"value": "423",
			"name": "浙江"
		}, {
			"value": "677",
			"name": "福建"
		}, {
			"value": "621",
			"name": "安徽"
		}, {
			"value": "177",
			"name": "江西"
		}, {
			"value": "1604",
			"name": "湖北"
		}, {
			"value": "464",
			"name": "湖南"
		}, {
			"value": "3656",
			"name": "广东"
		}, {
			"value": "376",
			"name": "广西"
		}, {
			"value": "150",
			"name": "贵州"
		}, {
			"value": "829",
			"name": "云南"
		}, {
			"value": "9",
			"name": "海南"
		}, {
			"value": "14",
			"name": "黑龙江"
		}, {
			"value": "49",
			"name": "吉林"
		}, {
			"value": "55",
			"name": "辽宁"
		}, {
			"value": "51346",
			"name": "陕西"
		}, {
			"value": "19349",
			"name": "新疆"
		}, {
			"value": "49209",
			"name": "内蒙古"
		}, {
			"value": "8561",
			"name": "青海"
		}, {
			"value": "-1",
			"name": "宁夏"
		}, {
			"value": "19872",
			"name": "甘肃"
		}, {
			"value": "5000",
			"name": "西藏"
		}, {
			"value": "2559",
			"name": "四川"
		}, {
			"value": "254",
			"name": "重庆"
		}],
		"nameName": "宁夏",
		"toatl": "195851"
	}, {
		"item": [{
			"value": "8",
			"name": "北京"
		}, {
			"value": "118",
			"name": "天津"
		}, {
			"value": "1070",
			"name": "河北"
		}, {
			"value": "710",
			"name": "山西"
		}, {
			"value": "2441",
			"name": "河南"
		}, {
			"value": "548",
			"name": "山东"
		}, {
			"value": "11",
			"name": "上海"
		}, {
			"value": "193",
			"name": "江苏"
		}, {
			"value": "84",
			"name": "浙江"
		}, {
			"value": "303",
			"name": "福建"
		}, {
			"value": "182",
			"name": "安徽"
		}, {
			"value": "64",
			"name": "江西"
		}, {
			"value": "456",
			"name": "湖北"
		}, {
			"value": "124",
			"name": "湖南"
		}, {
			"value": "1499",
			"name": "广东"
		}, {
			"value": "121",
			"name": "广西"
		}, {
			"value": "153",
			"name": "贵州"
		}, {
			"value": "532",
			"name": "云南"
		}, {
			"value": "3",
			"name": "海南"
		}, {
			"value": "5",
			"name": "黑龙江"
		}, {
			"value": "15",
			"name": "吉林"
		}, {
			"value": "30",
			"name": "辽宁"
		}, {
			"value": "48494",
			"name": "陕西"
		}, {
			"value": "11798",
			"name": "新疆"
		}, {
			"value": "5982",
			"name": "内蒙古"
		}, {
			"value": "9062",
			"name": "青海"
		}, {
			"value": "41172",
			"name": "宁夏"
		}, {
			"value": "-1",
			"name": "甘肃"
		}, {
			"value": "5669",
			"name": "西藏"
		}, {
			"value": "5033",
			"name": "四川"
		}, {
			"value": "164",
			"name": "重庆"
		}],
		"nameName": "甘肃",
		"toatl": "136044"
	}, {
		"item": [{
			"value": "0",
			"name": "北京"
		}, {
			"value": "0",
			"name": "天津"
		}, {
			"value": "1",
			"name": "河北"
		}, {
			"value": "2",
			"name": "山西"
		}, {
			"value": "13",
			"name": "河南"
		}, {
			"value": "1",
			"name": "山东"
		}, {
			"value": "0",
			"name": "上海"
		}, {
			"value": "0",
			"name": "江苏"
		}, {
			"value": "0",
			"name": "浙江"
		}, {
			"value": "0",
			"name": "福建"
		}, {
			"value": "0",
			"name": "安徽"
		}, {
			"value": "0",
			"name": "江西"
		}, {
			"value": "1",
			"name": "湖北"
		}, {
			"value": "0",
			"name": "湖南"
		}, {
			"value": "0",
			"name": "广东"
		}, {
			"value": "0",
			"name": "广西"
		}, {
			"value": "0",
			"name": "贵州"
		}, {
			"value": "18",
			"name": "云南"
		}, {
			"value": "0",
			"name": "海南"
		}, {
			"value": "0",
			"name": "黑龙江"
		}, {
			"value": "0",
			"name": "吉林"
		}, {
			"value": "0",
			"name": "辽宁"
		}, {
			"value": "0",
			"name": "陕西"
		}, {
			"value": "1",
			"name": "新疆"
		}, {
			"value": "0",
			"name": "内蒙古"
		}, {
			"value": "80",
			"name": "青海"
		}, {
			"value": "0",
			"name": "宁夏"
		}, {
			"value": "0",
			"name": "甘肃"
		}, {
			"value": "-1",
			"name": "西藏"
		}, {
			"value": "9",
			"name": "四川"
		}, {
			"value": "0",
			"name": "重庆"
		}],
		"nameName": "西藏",
		"toatl": "126"
	}, {
		"item": [{
			"value": "24",
			"name": "北京"
		}, {
			"value": "189",
			"name": "天津"
		}, {
			"value": "1882",
			"name": "河北"
		}, {
			"value": "502",
			"name": "山西"
		}, {
			"value": "1984",
			"name": "河南"
		}, {
			"value": "900",
			"name": "山东"
		}, {
			"value": "94",
			"name": "上海"
		}, {
			"value": "668",
			"name": "江苏"
		}, {
			"value": "512",
			"name": "浙江"
		}, {
			"value": "7309",
			"name": "福建"
		}, {
			"value": "339",
			"name": "安徽"
		}, {
			"value": "870",
			"name": "江西"
		}, {
			"value": "3521",
			"name": "湖北"
		}, {
			"value": "1691",
			"name": "湖南"
		}, {
			"value": "14154",
			"name": "广东"
		}, {
			"value": "4968",
			"name": "广西"
		}, {
			"value": "15509",
			"name": "贵州"
		}, {
			"value": "42469",
			"name": "云南"
		}, {
			"value": "363",
			"name": "海南"
		}, {
			"value": "113",
			"name": "黑龙江"
		}, {
			"value": "323",
			"name": "吉林"
		}, {
			"value": "288",
			"name": "辽宁"
		}, {
			"value": "27877",
			"name": "陕西"
		}, {
			"value": "7688",
			"name": "新疆"
		}, {
			"value": "489",
			"name": "内蒙古"
		}, {
			"value": "6119",
			"name": "青海"
		}, {
			"value": "889",
			"name": "宁夏"
		}, {
			"value": "1253",
			"name": "甘肃"
		}, {
			"value": "15666",
			"name": "西藏"
		}, {
			"value": "-1",
			"name": "四川"
		}, {
			"value": "17072",
			"name": "重庆"
		}],
		"nameName": "四川",
		"toatl": "175725"
	}, {
		"item": [{
			"value": "49",
			"name": "北京"
		}, {
			"value": "2978",
			"name": "天津"
		}, {
			"value": "1813",
			"name": "河北"
		}, {
			"value": "491",
			"name": "山西"
		}, {
			"value": "4396",
			"name": "河南"
		}, {
			"value": "2102",
			"name": "山东"
		}, {
			"value": "151",
			"name": "上海"
		}, {
			"value": "2210",
			"name": "江苏"
		}, {
			"value": "2302",
			"name": "浙江"
		}, {
			"value": "22230",
			"name": "福建"
		}, {
			"value": "779",
			"name": "安徽"
		}, {
			"value": "4123",
			"name": "江西"
		}, {
			"value": "14339",
			"name": "湖北"
		}, {
			"value": "33212",
			"name": "湖南"
		}, {
			"value": "26465",
			"name": "广东"
		}, {
			"value": "8168",
			"name": "广西"
		}, {
			"value": "76899",
			"name": "贵州"
		}, {
			"value": "37150",
			"name": "云南"
		}, {
			"value": "633",
			"name": "海南"
		}, {
			"value": "86",
			"name": "黑龙江"
		}, {
			"value": "262",
			"name": "吉林"
		}, {
			"value": "338",
			"name": "辽宁"
		}, {
			"value": "15151",
			"name": "陕西"
		}, {
			"value": "13212",
			"name": "新疆"
		}, {
			"value": "907",
			"name": "内蒙古"
		}, {
			"value": "1682",
			"name": "青海"
		}, {
			"value": "380",
			"name": "宁夏"
		}, {
			"value": "292",
			"name": "甘肃"
		}, {
			"value": "3938",
			"name": "西藏"
		}, {
			"value": "159360",
			"name": "四川"
		}, {
			"value": "-1",
			"name": "重庆"
		}],
		"nameName": "重庆",
		"toatl": "436098"
	}]
}